<div class="d-flex h-100">
  <form [formGroup]="form" class="align-form">
    <div *ngFor="let formField of masterFormField"
      class="form-group d-grid grid-column-gap20 make-responsive-fit align-items-center mr-2">
      <div *ngIf="formField.fieldType === 'text' || formField.fieldType === 'number'" class="field">
        <label>{{ formField.name }}</label>
        <input class="form-control" type="{{ formField.fieldType }}" value="{{ formField.path }}" formControlName="{{ formField.path }}" />
      </div>
      <div *ngIf="formField.fieldType === 'dropdown'" class="field">
        <mat-form-field class="field">
          <mat-label>{{ formField.name }}</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="{{ formField.path }}" multiple
            panelClass="rightFilterSelectPanel">
            <mat-option *ngFor="let item of formField.fieldValue" [value]="item">
              {{ item | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="formField.fieldType === 'inputDropdown'" class="field">
        <mat-form-field class="field" (click)="$event.stopPropagation();">
          <mat-label>{{ formField.name }}</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="{{ formField.path }}"
            [multiple]="formField?.isMultiSelect" [panelClass]="setPanelClass(formField?.isMultiSelect)">
            <mat-option *ngFor="let item of formField.fieldValue" [value]="item" (click)="onSelectOptionClick('to')">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="formField.fieldType === 'description'" class="field -text-area-field-height">
        <mat-form-field class="field">
          <mat-label>{{ formField.name }}</mat-label>
          <textarea matInput cdkTextareaAutosize appjsonvalidator="" formControlName="{{ formField.path }}"
            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
        </mat-form-field>
      </div>
      <div *ngIf="formField.fieldType === 'input'" class="field">
        <mat-form-field class="field">
          <mat-label>{{ formField.name }}</mat-label>
          <input matInput formControlName="{{ formField.path }}">
        </mat-form-field>
      </div>
    </div>
    <div class="btn-basket" *ngIf="isButtonPresent">
      <button mat-button (click)="onSubmit(ACTION_MODE?.CLEAR)"
        class="mat-focus-indicator mat-raised-button mat-button-base mat-primary">Clear</button>
      <button mat-button type="submit" [disabled]="form.invalid" (click)="onSubmit()"
        class="mat-focus-indicator mat-raised-button mat-button-base mat-primary">Submit</button>
    </div>
  </form>
  <div *ngIf="isPushNotification" class="push-notify">
    mobileAppId : {{form.value?.toUser?.mobileAppId}}<br>
    mobileToken : {{form.value?.toUser?.mobileToken}}
  </div>
</div>